<template>
  <div v-for="i in items" :key="i" class="flex flex-col gap-2 justify-center">
    <Shimmer v-if="showTitle" width="200px" height="22px" radius="4px" />
    <Shimmer width="100%" height="40px" radius="4px" />
  </div>
</template>
<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  items: {
    type: Number,
    default: 5
  },
  showTitle: {
    type: Boolean,
    default: true
  }
});
</script>
